import styled from "styled-components";

const IndentedSection = styled.div`
  padding: 0 0 0 20px;
  margin: 0 0 1em 0;
  border-left: 3px solid ${(props) => props.theme.color.powder_blue};
`;

export default IndentedSection;
